import moment from 'moment';
const DEFAULT_DATE_FORMAT = "YYYY-MM-DD";
const DEFAULT_TIME_FORMAT = "HH:mm";
function format(input, format2) {
  let useUTC = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (useUTC) return moment.utc(input).format(format2);
  return moment(input).format(format2);
}
function parse(dateString, format2) {
  const parsed = moment(dateString, format2, true);
  if (parsed.isValid()) {
    return {
      isValid: true,
      date: parsed.toDate()
    };
  }
  return {
    isValid: false,
    error: 'Invalid date. Must be on the format "'.concat(format2, '"')
  };
}
export { DEFAULT_DATE_FORMAT, DEFAULT_TIME_FORMAT, format, parse };
//# sourceMappingURL=legacyDateFormat.esm.js.map
